import {customElement, DOM, bindable, bindingMode, computedFrom} from 'aurelia-framework';
import {kebabCasedStyleProp} from '../../../tools/bfdt';

@customElement('scrollbar')
export class Scrollbar {

  /**
   * @type {number|null}
   */
  @bindable({defaultBindingMode: bindingMode.oneTime})
  minSliderLength;

  /**
   * @type {number|null}
   */
  @bindable({defaultBindingMode: bindingMode.oneTime})
  maxSliderLength;

  /**
   * @type {boolean}
   */
  @bindable({defaultBindingMode: bindingMode.oneWay})
  isVisible: boolean = false;
  isMouseOver: boolean = false;
  interacting: boolean = false;

  @bindable({defaultBindingMode: bindingMode.oneWay})
  areaHeight: number = 0;
  @bindable({defaultBindingMode: bindingMode.oneWay})
  scrollHeight: number = 0;
  @bindable({defaultBindingMode: bindingMode.twoWay})
  translate: number = 0;

  sliderHeight: number = 0;
  sliderTranslateY: number = 0;
  transformProp: string = kebabCasedStyleProp('transform');
  __movingPrevY: number;
  __movingStartTranslateY: number;

  private __maxTranslateY: number = 0;

  @computedFrom('isMouseOver', 'interacting', 'sliderHeight', 'isVisible')
  get style() {
    let hovered = this.isMouseOver || this.interacting ? 'hovered' : '';
    let visible = this.sliderHeight > 0 && this.isVisible || this.interacting ? 'visible' : '';
    return `${hovered} ${visible}`;
  }

  areaHeightChanged() {
    this.__updateSliderHeight();
  }

  scrollHeightChanged() {
    this.__updateSliderHeight();
  }

  translateChanged() {
    this.__updatePosition();
  }

  startSliderMovingY(e: MouseEvent) {
    this.interacting = true;
    this.__movingPrevY = e.pageY;
    this.__movingStartTranslateY = this.sliderTranslateY;

    let onMouseMove, onMouseUp;
    DOM.addEventListener('mousemove', onMouseMove = e => this.__onSliderMoveY(e), true);
    DOM.addEventListener('mouseup', onMouseUp = () => {
      this.interacting = false;
      DOM.removeEventListener('mousemove', onMouseMove, true);
      DOM.removeEventListener('mouseup', onMouseUp, true);
    }, true);
  }

  /**
   * @private
   */
  __updatePosition() {
    this.sliderTranslateY = this.translate * (this.sliderHeight - this.areaHeight) /
      (this.scrollHeight - this.areaHeight);
  }

  /**
   * @private
   */
  __updateTranslate() {
    this.translate = this.sliderTranslateY * (this.scrollHeight - this.areaHeight) /
      (this.sliderHeight - this.areaHeight);
  }

  /**
   * @private
   */
  __updateSliderHeight() {
    if (this.scrollHeight > this.areaHeight) {
      let height = this.areaHeight * this.areaHeight / this.scrollHeight;
      if (this.minSliderLength !== null && height <= this.minSliderLength) {
        this.sliderHeight = this.minSliderLength;
      } else if (this.maxSliderLength !== null && height >= this.maxSliderLength) {
        this.sliderHeight = this.maxSliderLength;
      } else {
        this.sliderHeight = height;
      }
    } else {
      this.sliderHeight = 0;
    }

    this.__maxTranslateY = this.areaHeight - this.sliderHeight;
  }

  /**
   * @param {MouseEvent} e
   * @private
   */
  __onSliderMoveY(e) {
    let translate = e.pageY - this.__movingPrevY + this.__movingStartTranslateY;
    if (translate <= 0) {
      this.sliderTranslateY = 0;
    } else if (translate >= this.__maxTranslateY) {
      this.sliderTranslateY = this.__maxTranslateY;
    } else {
      this.sliderTranslateY = translate;
    }

    this.__updateTranslate();
  }

}
